/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithIsActiveItemRequestBuilder, WithIsActiveItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /FlightNumber/{id}
 */
export interface FlightNumberItemRequestBuilder extends BaseRequestBuilder<FlightNumberItemRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.FlightNumber.item.item collection
     * @param isActive Unique identifier of the item
     * @returns {WithIsActiveItemRequestBuilder}
     */
     byIsActive(isActive: boolean) : WithIsActiveItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const FlightNumberItemRequestBuilderUriTemplate = "{+baseurl}/FlightNumber/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FlightNumberItemRequestBuilderNavigationMetadata: Record<Exclude<keyof FlightNumberItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byIsActive: {
        requestsMetadata: WithIsActiveItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["isActive"],
    },
};
/* tslint:enable */
/* eslint-enable */
